import React from "react";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import DeviceInfoColumn from "../../../../components/DeviceInfoColumn";
import SubstringWithDot from "../../../../components/SubstringWithDot";
import CheckboxColumn from "../../../../components/CheckboxColumn";
import ConnectionStatus from "../../../../components/ConnectionStatus";
import NetworkDeviceActions from "./NetworkDeviceActionButtons";
import {connect} from "react-redux";
import {claimTypes} from "../../../../constants/claim.constants";
import SwitchDiagnosticMode from "../../../../components/SwitchDiagnosticMode";
import SwitchIgnoreSchedule from "../../../../components/SwitchIgnoreSchedule";
import SimpleConnectionStatus from "../../../../components/SimpleConnectionStatus";
import NetworkDeviceListMobileView from "../_mobile/NetworkDeviceListMobileView";
import {networkDeviceIsSimpleOnlineStatus} from "../../../../helpers/network-device-state.helper";


const NetworkDeviceTable = ({list, selectedDeviceType, selectedStatusValue, selectedArea, selectedDeviceGroup, areas,  user, t}) => {
    // default list
    let resultList = list;

    // claims
    const soundControlPermission = user['c_dashboard.sound-control'] || null;
    const diagnosticModePermission = user[`c_network-device.actions.diagnostic-mode`] || null;

    if(selectedDeviceType !== 0) {
        resultList = resultList?.filter((item) => item.deviceTypeId === selectedDeviceType);
    }

    if(selectedArea !== null) {
        const findArea = areas.find((item) => item.id === selectedArea);
        resultList = resultList?.filter((item) => item.label.includes(findArea.inclx));
    }

    if(selectedDeviceGroup !== null) {
        resultList = resultList?.filter((item) => item.deviceGroupIds.includes(selectedDeviceGroup))
    }

    if(typeof selectedStatusValue === "boolean") {
        resultList = resultList?.filter((item) => item.isOnline === selectedStatusValue && item.isOnlineNetwork === selectedStatusValue);
    }

    if(selectedStatusValue === "warning") {
        resultList = resultList?.filter((item) => (item.isOnline === false && item.isOnlineNetwork === true) || (item.isOnline === true && item.isOnlineNetwork === false));
    }


    // columns
    const columns = [
        {
            Header: 'type',
            accessor: 'deviceType.label',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-wrap',
        },
        {
            Header: 'device',
            accessor: 'device',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <DeviceInfoColumn networkDevice={data} />
                )
            }
        },
        {
            Header: 'description',
            accessor: 'description',
            classNameRow: 'text-wrap',
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <SubstringWithDot classNames="desc ws-n" stringData={data.description} numberChar={70} />
                )
            }
        },
        {
            Header: 'diagnostic-mode',
            accessor: 'diagnostic-mode',
            headerClassName: "text-center text-wrap",
            classNameRow: 'text-center',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <SwitchDiagnosticMode  networkDeviceId={data.id}  dataValue={data.diagnosticMode} />
                )
            }
        },

        {
            Header: 'ignore-schedule',
            accessor: 'ignore-schedule',
            headerClassName: "text-center text-wrap",
            classNameRow: 'text-center',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <SwitchIgnoreSchedule  networkDeviceId={data.id}  dataValue={data.ignoreSchedule} />
                )
            }
        },
        {
            Header: 'status',
            accessor: 'status',
            headerClassName: " text-center wrapok",
            classNameRow: 'text-center',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    !networkDeviceIsSimpleOnlineStatus(data.deviceType.label) ?
                        <ConnectionStatus status={data.isOnline} networkStatus={data.isOnlineNetwork} /> :
                        <SimpleConnectionStatus status={data.isOnlineNetwork} hideDescription={true} />
                )
            },
        },
        {
            Header: 'actions',
            accessor: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right wrapok',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <NetworkDeviceActions row={data} />
                )
            }
        }
    ];



    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { resultList?.length ? (
                <div>
                    <div className="d-none d-lg-block">
                        <HilightTable
                            columns={columns}
                            data={resultList}
                        />
                    </div>
                    <div className="d-block d-lg-none">
                        <NetworkDeviceListMobileView data={resultList}/>
                    </div>
                </div>
            ) : (
                <div className="text-center p-4">
                    <h3>{ t('network-device-no-content')  }</h3>
                </div>
            ) }
        </div>
    );
};

const mapStateToProps = state => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceTable));
